import { useCallback, useEffect, useMemo } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useTranslate } from 'lib/tolgee'
import { PanelStore } from 'stores'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import type { IListGlobalTopicsPage, TTabs } from './list-global-topics-page.types'

export const useListGlobalTopicsPageModel = (): IListGlobalTopicsPage => {
  const { topicsType } = useParams<{ topicsType?: TTabs }>()
  const history = useHistory()
  const t = useTranslate()

  const workspaceId = Object(PanelStore?.selectedPanel)?.panelId

  const getTabPath = useCallback(
    (tab: string) => {
      const path = getRoute(PATHNAMES.WORKSPACE_TOPICS, { panelId: workspaceId, topicsType: tab })
      return path
    },
    [workspaceId]
  )

  const currentTab = topicsType

  const tabs = useMemo(() => {
    const handleTrack = (tab: string) => {
      return () => {
        const { TOP_OPEN_SEARCH } = analyticsTracker.eventNames
        analyticsTracker.eventTrack(TOP_OPEN_SEARCH, {
          'Page name': 'Topics',
          'Tab title': tab,
        })
      }
    }
    const baseTabs = [
      {
        label: t(TOLGEE_GLOBALS.winninTopics),
        key: 'territories',
      },
      {
        label: t(TOLGEE_GLOBALS.ownedTopics),
        key: 'owned',
      },
      {
        label: t(TOLGEE_GLOBALS.favorites),
        key: 'favorites',
      },
    ]
    return baseTabs.map(tab => {
      return {
        ...tab,
        onClick: handleTrack(tab.key),
        path: getTabPath(tab.key),
      }
    })
  }, [getTabPath, t])

  useEffect(() => {
    const defaultTab = getTabPath('territories')
    if (!topicsType) {
      history.replace(defaultTab)
    }
  }, [getTabPath, history, topicsType])

  return { tabs, currentTab }
}
